import { WhiteBalanceSunnyIcon } from './WhiteBalanceSunnyIcon';

/**
 * author: Google
 * id 7DCAB3C3-C32F-483D-98F1-1728919AA17B
 * name white-balance-sunny
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/white-balance-sunny.svg
 * tags
 * - Photography 
 * - Weather 
 */
export const WbSunnyIcon = WhiteBalanceSunnyIcon;
export default WbSunnyIcon